import { api } from "./api";
import { endpoints } from "./endpoints";

export interface PurchaseCreditPayload {
  teamSchema: string;
  user: {
    userId?: number;
    accountId: number;
    accountGroup?: number;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
  };
  creditPack: {
    amount: number;
  };
  cardDetail?: {
    cardNumber: string;
    cardCvc: number;
    cardExpiry: string;
    address: string;
    zipCode: number;
    firstName: string;
    lastName: string;
    saveCard: boolean;
  };
  savedCard?: {
    ccSeqId: number;
    ccType: string;
  };
}

interface LockSeatsForCreditPayload {
  teamSchema: string;
  creditPack: {
    eventCode: string;
    seatCount: number;
    priceCode: string;
    ticketTypeCode: string;
    accountGroupId: number;
    accountGroupName: string;

    id: number;
    title: string;
    amount: number;
  };
}

export const purchaseCreditApi = async (payload: PurchaseCreditPayload) => {
  return await api.post(endpoints.purchaseCredit, payload, {
    timeout: 30000,
  });
};

export const getCreditPacksApi = async (payload: { teamSchema: string }) => {
  const res = await api.post(endpoints.getCreditPacks, payload);
  if (res?.request?.status === 200) {
    res.data.map((itm: any) => {
      itm.amount = Number(itm.amount);
      itm.serviceFee = Number(itm.serviceFee);
      return itm;
    });
  }
  return res;
};

export const getCreditReportApi = async (payload: { teamSchema: string }) => {
  return await api.post(endpoints.getCreditReport, payload);
};

export const getCheckoutCreditApi = async (payload: {
  teamSchema: string;
  tmCheckoutCredit?: {
    cartId: number;
    totalAmount: number;
    sessionId: string;
  };
}) => {
  return await api.post(endpoints.getCheckoutCredit, payload);
};

export const lockSeatsForCreditApi = async (
  payload: LockSeatsForCreditPayload
) => await api.post(endpoints.lockSeatsForCredit, payload);

export const cancelCartForCreditApi = async (payload: {
  teamSchema: string;
  cartId: number;
  sessionId: string;
}) => await api.post(endpoints.cancelCartForCredit, payload);
